import { Injectable } from '@angular/core';
import { GlobalMethodsService } from '../global-methods.service';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { GlobalVariablesService } from '../global-variables.service';
import { NavigationService } from './navigation.service';
import { tap, take } from 'rxjs/operators';
import { UserRequest } from '../SicorService/RequestObject/UserRequest';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { AppUserHomeRequest } from '../SicorService/RequestObject/AppUserHomeRequest';
import { DefaultModalComponent } from '../../components/modals/default-modal/default-modal.component';
import { UserLogin } from '../../models/UserLogin';
import { StorageService } from './storage.service';
import { Installation } from '../../models/Installation';
import { ModalController } from '@ionic/angular';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { LastInsRequest } from '../SicorService/RequestObject/LastInsRequest';
import { firstValueFrom } from 'rxjs';
import { AppUserCardNewRequest } from '../SicorService/RequestObject/AppUserCardNewRequest';
import { CardNew } from '../../models/CardNew';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PanelConfService {

  constructor(public gms: GlobalMethodsService,
    private sicorAPI: SicorApiService,
    public gvs: GlobalVariablesService,
    private navigation: NavigationService,
    private translate: TranslateConfigService,
    private storage: StorageService) { }

  async getInstallations(user: string, lang: string): Promise<Installation[]> {
    const userRequest: UserRequest = {
      user,
      lang,
      app_name: 'SIC'
    };
    const storageConfInstallations: Installation[] = await this.storage.getObject(this.gvs.CONF_INSTALLATIONS + '_' + user);
    let installations: Installation[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.listInstallation(userRequest)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
                resolve(installations);
              }
              if (res.returnCode != null && res.returnCode === 0) {
                installations = res.resultSet;
                if (installations != null && installations.length > 0) {
                  try {
                    let confInstallations: Installation[] = [];
                    installations.forEach(element => {
                      let tempInstallation: Installation = new Installation();
                      tempInstallation.setInstallation(element.s_ins, element.user_name, element.ins_no, element.ins_name, element.s_cont,
                        element.cix, element.pix, element.s_pc, element.selected, element.ins_lat, element.ins_lon, element.cust_support_phone, element.settings,
                        element.alias, element.ctr_no, element.street1, element.alias != '' ? element.alias : element.ins_name, 0, 0, 0, element.clientCategory,
                        element.tariffName, element.tariffCategory, element.userid);
                      confInstallations.push(tempInstallation);
                    });
                    if (storageConfInstallations != null) {
                      for (let i = 0; i < confInstallations.length; i++) {
                        let installation = storageConfInstallations.find(x => x.s_ins === confInstallations[i].s_ins);
                        if (installation != null) {
                          confInstallations[i].geoAround = installation.geoAround;
                          confInstallations[i].distance = installation.distance;
                          confInstallations[i].alarmNotificationIn = installation.alarmNotificationIn;
                          confInstallations[i].alarmNotificationOut = installation.alarmNotificationOut;
                        }
                      }
                    }
                    await this.storage.setObject(this.gvs.CONF_INSTALLATIONS + '_' + user, confInstallations);
                    let installationList: Installation[] = await this.storage.getObject(this.gvs.CONF_INSTALLATIONS + '_' + user);
                    if (installationList != null && installationList.length > 0) {
                      const installation: Installation = installationList.find(x => x.selected === 1);
                      if (installation != null) {
                        this.gvs.currentInstallation = installation;
                      } else {
                        this.gvs.currentInstallation = installationList[0];
                      }
                    }
                    resolve(installations);
                  } catch (e) {
                    const message = JSON.stringify(e);
                    await FirebaseCrashlytics.recordException({ message: message });
                    resolve(null);
                  }
                } else {
                  resolve(installations);
                }
              } else {
                resolve(installations);
              }
            }
          }, error: async e => {
            resolve(null);
          }
        })
      ));
    });
  }

  public async setListInstallations(s_ins: number, user: string) {
    const appUserHomeRequest: AppUserHomeRequest = new AppUserHomeRequest(s_ins, user);
    return firstValueFrom((await this.sicorAPI.cAppUserHome(appUserHomeRequest)).pipe(
      take(1),
      tap({
        next: async res => {
          if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
            await this.navigation.logout();
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }
        }, error: async e => {
        }
      })
    ));
  }

  public async setLastIns(s_ins: number, user: string, s_ins_new: number): Promise<boolean> {
    const lastInsRequest: LastInsRequest = new LastInsRequest(s_ins, user, s_ins_new, 'SIC');
    return new Promise(async (resolve, reject) => {
     await firstValueFrom((await this.sicorAPI.cAppuserLastIns(lastInsRequest)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
                resolve(false)
              } else {
                resolve(true);
              }
            }
          }, error: async e => {
            resolve(false);
          }
        })
        ));
    });
  }

  async getCardsNews(user: string, s_ins: number): Promise<CardNew[]> {
    const appUserCardNewRequest: AppUserCardNewRequest = new AppUserCardNewRequest(user, s_ins, 'SIC', environment.APP_VERSION)
    let cardsNews: CardNew[] = [];
    const storageCardsNews: CardNew[] = await this.storage.getObject(this.gvs.CARDS_NEWS);

    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.gAppUserCardNewsRequest(appUserCardNewRequest)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet[0] != null) {
              if(res.resultSet[0].error != null){
                if(res.resultSet[0].error === 401){
                  await this.navigation.logout();
                  await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
                  resolve(cardsNews);
                }else if(res.resultSet[0].error === 0){
                  resolve(cardsNews);
                }else{
                  resolve(cardsNews);
                }
              }else{
                cardsNews = res.resultSet;
                if (cardsNews != null && cardsNews.length > 0) {
                  try{
                    for (let i = 0; i < cardsNews.length; i++) {
                      cardsNews[i].visible = true;
                    }
                    if (storageCardsNews != null) {
                      for (let i = 0; i < cardsNews.length; i++) {
                        let cardNew = storageCardsNews.find(x => x.id_card === cardsNews[i].id_card);
                        if (cardNew != null) {
                          cardsNews[i].card_base64 = cardNew.card_base64;
                          cardsNews[i].visible = cardNew.visible;
                        }
                      }
                    }
                    await this.storage.setObject(this.gvs.CARDS_NEWS, cardsNews);
                    resolve(cardsNews);
                  }catch(e){
                    resolve(null);
                  }
                }else{
                  resolve(cardsNews);
                }
              }
            }else{
              resolve(cardsNews);
            }
          },
          error: e => {
            resolve(null);
          }
        })
      ));
    });

  }
}
